/* eslint-disable react/require-default-props */
import { useRef } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Form } from '@openedx/paragon';
import { fieldEvents } from 'utils/eventing';
import { getCorrelationID, hyphenateForTagular } from 'utils/tagular';
import { useCart } from 'frontastic/hooks';
import { FormError } from './form-error';
import { FormInputProps } from './types';

export const FormInput = ({
  name,
  label,
  styleClasses,
  labelStyleClasses = '',
  autocomplete,
  maxLength,
  type = 'text',
  disabled = false,
  onChange,
}: FormInputProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const error = errors[name]?.message;
  const hasFiredEvent = useRef(false);
  const { data: cart } = useCart();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(event.target.value);
    }

    if (!hasFiredEvent.current) {
      const fieldEvent = fieldEvents({
        correlationId: getCorrelationID(),
        userInputField: {
          fieldId: name,
          fieldLabel: name,
          fieldName: name,
          fieldType: name,
          fieldValue: 'SANITIZED',
        },
        formContext: {
          formBrand: hyphenateForTagular(
            cart?.lineItems?.[0]?.variant?.attributes?.['brand-text'] ?? '',
          ),
          formId: cart?.lineItems?.[0]?.variant?.sku,
          formName: cart?.lineItems?.[0]?.name,
          formType: cart?.lineItems?.[0]?.productType?.obj?.name,
        },
      });

      fieldEvent.fieldInputted();
      hasFiredEvent.current = true;
    }
  };

  return (
    <Form.Group className={styleClasses} isInvalid={!!error} controlId={name}>
      {label && <Form.Label className={labelStyleClasses}>{label}</Form.Label>}
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <>
            <Form.Control
              {...field}
              disabled={disabled}
              maxLength={maxLength}
              autoComplete={autocomplete}
              type={type}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                field.onChange(e);
                handleChange(e);
              }}
            />
            <FormError error={error} value={field.value as string} />
          </>
        )}
      />
    </Form.Group>
  );
};
